/**
 * Rota /funis/carrinho.
 *
 * A pagina inteira mora em `PaginaDoFunil`; este arquivo so fixa o `kind`.
 * Assim a rota de expirados e esta nunca divergem em estrutura.
 */

import { PaginaDoFunil } from '../components/PaginaDoFunil';

export function FunilCarrinho(): JSX.Element {
  return <PaginaDoFunil kind="carrinho_abandonado" />;
}
